import type { I18nLocale } from "@/modules/i18n/types"

import { RESULTS_SORT_OPTIONS_MAPPING } from "@/modules/jobAds/client/constants"

type ResultsSortOptionsMapping = keyof typeof RESULTS_SORT_OPTIONS_MAPPING

const LOCALES_WITH_DEDICATED_INDEX: I18nLocale[] = ["en", "es", "de", "da", "fi"]

const isSortFromMapping = (value: string): value is ResultsSortOptionsMapping => {
  return Object.keys(RESULTS_SORT_OPTIONS_MAPPING).includes(value)
}

export const getAlgoliaIndexName = ({
  algoliaIndexNameFromUnleash,
  locale,
  sort,
}: {
  algoliaIndexNameFromUnleash: string | undefined
  locale: I18nLocale
  sort: string | string[] | null | undefined
}): (typeof RESULTS_SORT_OPTIONS_MAPPING)[keyof typeof RESULTS_SORT_OPTIONS_MAPPING] => {
  const sortType = Array.isArray(sort) ? sort[0].toUpperCase() : (sort || "RELEVANCE")?.toUpperCase()
  const sortTypeIsRelevance = sortType === "RELEVANCE"

  if (sortTypeIsRelevance && algoliaIndexNameFromUnleash) {
    return algoliaIndexNameFromUnleash
  }

  if (sortTypeIsRelevance && LOCALES_WITH_DEDICATED_INDEX.includes(locale)) {
    return `${RESULTS_SORT_OPTIONS_MAPPING[sortType as ResultsSortOptionsMapping]}_${locale}`
  }

  if (sortType && isSortFromMapping(sortType)) {
    return RESULTS_SORT_OPTIONS_MAPPING[sortType as ResultsSortOptionsMapping]
  }

  return RESULTS_SORT_OPTIONS_MAPPING.RELEVANCE
}
